/** Phosphor weights (https://phosphoricons.com), each one is a SVG sprite in `libs/shared/src/assets/icons` */
export type IconWeight = 'thin' | 'light' | 'regular' | 'fill' | 'duotone';
/** All icon weights */
export const ICON_WEIGHTS: IconWeight[] = ['thin', 'light', 'regular', 'fill', 'duotone'];

/** Possible animations of icons */
export type IconAnimation = 'spin' | 'pulse' | 'bounce' | 'flip' | 'shake' | 'beat' | 'fade' | 'beat-fade' | 'none';
/** All icon animations */
export const ICON_ANIMATIONS: IconAnimation[] = ['spin', 'pulse', 'bounce', 'flip', 'shake', 'beat', 'fade', 'beat-fade', 'none'];

/**
 * Icons of the SVG sprites: Phosphor names (https://phosphoricons.com) and the brand logos (`brand-…`)
 * - The brand logos are the original logos of FontAwesome Free (CC BY 4.0), Phosphor only has own line drawings of logos
 * - After a change run `npx tsx ./build-icon-sprites.ts`
 */
export const ICON_NAMES = [
  'align-bottom',
  'align-center-horizontal',
  'align-center-vertical',
  'align-left',
  'align-right',
  'align-top',
  'archive',
  'arrow-line-down',
  'arrow-right',
  'arrow-square-out',
  'arrows-clockwise',
  'arrows-out',
  'arrows-out-cardinal',
  'arrows-vertical',
  'basket',
  'bell',
  'book-open',
  'bookmark',
  'brand-facebook',
  'brand-facebook-f',
  'brand-instagram',
  'brand-linkedin',
  'brand-pinterest',
  'brand-tiktok',
  'brand-twitter',
  'brand-whatsapp',
  'brand-x-twitter',
  'brand-xing',
  'brand-youtube',
  'briefcase',
  'building',
  'calculator',
  'calendar',
  'calendar-blank',
  'calendar-check',
  'calendar-dots',
  'calendar-star',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-up',
  'caret-up-down',
  'cash-register',
  'certificate',
  'chat-text',
  'chats',
  'check',
  'circle-notch',
  'clipboard',
  'clipboard-text',
  'clock',
  'clock-counter-clockwise',
  'code',
  'code-block',
  'confetti',
  'copy',
  'credit-card',
  'crop',
  'cross',
  'cube',
  'cursor',
  'database',
  'desktop',
  'device-mobile',
  'device-tablet',
  'download-simple',
  'envelope',
  'envelope-open',
  'envelope-simple',
  'eye',
  'eye-slash',
  'file',
  'file-arrow-down',
  'file-text',
  'files',
  'floppy-disk',
  'flower',
  'folder',
  'folder-open',
  'folders',
  'fork-knife',
  'funnel',
  'gear',
  'gear-six',
  'gift',
  'git-branch',
  'globe',
  'hard-hat',
  'heart',
  'house',
  'identification-card',
  'image',
  'images',
  'info',
  'key',
  'link',
  'link-break',
  'list',
  'list-checks',
  'lock',
  'magic-wand',
  'magnifying-glass',
  'magnifying-glass-minus',
  'magnifying-glass-plus',
  'map-pin',
  'map-trifold',
  'medal',
  'minus',
  'minus-circle',
  'newspaper',
  'note-pencil',
  'paint-brush',
  'palette',
  'path',
  'pen',
  'pencil',
  'pencil-ruler',
  'phone',
  'play',
  'play-circle',
  'plus',
  'printer',
  'question',
  'receipt',
  'rectangle',
  'ruler',
  'share-network',
  'shield-check',
  'shopping-cart',
  'sign-in',
  'sign-out',
  'sliders',
  'smiley',
  'smiley-sad',
  'spinner',
  'squares-four',
  'stack',
  'star',
  'stethoscope',
  'storefront',
  'text-t',
  'ticket',
  'translate',
  'trash',
  'truck',
  'upload-simple',
  'user',
  'user-check',
  'user-gear',
  'user-list',
  'user-minus',
  'user-plus',
  'user-rectangle',
  'users',
  'warning',
  'warning-circle',
  'x',
  'x-circle',
  'x-square'
] as const;
/** Name of an icon of the SVG sprites */
export type IconName = (typeof ICON_NAMES)[number];

/** Icon Interface */
export interface IIcon {
  /** Name of the icon, e.g. 'magnifying-glass' */
  name: IconName;
  /** Weight of the icon, e.g. 'fill' */
  weight: IconWeight;
  /** Optional animation for the icon */
  animation?: IconAnimation;
}

/**
 * Mapping of social media platforms to their brand logos
 */
export const SOCIAL_MEDIA_ICON_MAP: Record<string, IconName> = {
  facebook: 'brand-facebook',
  instagram: 'brand-instagram',
  linkedIn: 'brand-linkedin',
  x: 'brand-x-twitter',
  pinterest: 'brand-pinterest',
  tikTok: 'brand-tiktok',
  xing: 'brand-xing',
  youtube: 'brand-youtube'
};
